import type { Tracking } from '@components/global'
import { useBrand } from '@contexts/useBrand'
import { formEvent } from '@utils/helpers/tracking'
import { marked } from 'marked'
import type { ReactElement } from 'react'
import { useEffect } from 'react'

type ModelObj = {
  conversion: number
  name: string
  step: string
  variant: string
}

type DealerObj = {
  conversion: number
  name: string
  step: string
  variant: string
}

type Props = {
  title?: string
  subtitle?: string
  active: boolean
  models?: ModelObj
  dealer?: DealerObj
  user?: boolean
  tracking?: Tracking
  step?: number
  noContainer?: boolean
  noPadding?: boolean
  children: ReactElement | ReactElement[]
}

const FormStep = ({
  title,
  subtitle,
  active,
  user,
  tracking,
  step,
  children,
  noContainer = false,
  noPadding = false,
}: Props) => {
  const brand = useBrand()

  useEffect(() => {
    if (active && tracking && user) {
      formEvent(tracking, brand)
    }
  }, [step])

  if (!active) {
    return null
  }

  return (
    <div
      className={`flex flex-col grow text-base-text ${
        !noContainer ? 'container my-8 md:my-10 lg:my-[60px]' : ''
      } ${noPadding ? 'container mb-8 md:mb-10 lg:mb-[60px]' : ''}`}
    >
      {title && (
        <h3
          className={`text-xl md:text-2xl lg:text-3xl mb-3 !leading-snug ${
            subtitle ? '' : 'mb-8 md:mb-10 lg:mb-10'
          }`}
        >
          {title}
        </h3>
      )}

      {subtitle && (
        <div
          className={`${
            brand === 'lexus' ? 'text-lg' : 'text-md'
          } pb-8 md:pb-10 !normal-case last:[&>p]:mb-0 [&>p]:mb-3 [&>p>a]:underline`}
          dangerouslySetInnerHTML={{
            __html: marked.parse(subtitle, { mangle: false, headerIds: false }),
          }}
        />
      )}
      {children}
    </div>
  )
}

export default FormStep
